// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/pc_mall_intact/assets/css/common.css
// module id = SNMH
// module chunks = 35